import React from "react";
import { useHistory } from "react-router-dom";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import { Api } from "./../app-controller.js";
import { useAuth } from "../components/content/auth.jsx";

class EstablecimientosCuarentena extends React.Component {
  constructor(props) {
    super(props);

    if (props.auth.user.name === undefined) {
      this.props.history.push("login");
    }

    this.state = {
      nivelUsuario: localStorage.nivel_actual,
    };
  }

  componentDidMount() {
    // si el usuario no es nivel cuarentena redireccionamos a home
    if (this.state.nivelUsuario !== "6") {
      window.location.href = "/";
    }

    let grid = {
      source: "app/getEstablecimientoCuarentena",
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        folio_establecimiento: {
          label: "Folio establecimiento",
        },
        razon_social: {
          label: "Nombre establecimiento",
        },
        actividad: {
          label: "Actividad",
        },
        estatus: {
          label: "Estado",
        },
      },
    };

    let mi_grid = Api.grid(grid);

    let busqueda = Api.form({
      target: "#busqueda",
      onchange: (me, data, serial) => {
        mi_grid.go(1, serial);
      },
      render: (form) => {
        /** Cargamos el combo de estatus */
        Api.fetch("app/getEstatusLicenciaEstablecimiento").then((data) => {
          if (data) {
            let estatus = data;
            let option_e = `<option value="0">Seleccione el estado del establecimiento</option>`;
            for (let e in estatus) {
              option_e += `<option value="${estatus[e].id}">${estatus[e].descripcion}</option>`;
            }
            form.querySelector("#estatus").innerHTML = option_e;
          }
        });
        /* Fin de la carga estatus */

        /** Cargamos el combo de actividades */
        Api.fetch("app/getActividadesCuarentena").then((data) => {
          if (data) {
            let actividad = data;
            let option_a = `<option value="0">Seleccione la actividad del establecimiento</option>`;
            for (let a in actividad) {
              option_a += `<option value="${actividad[a].id}">${actividad[a].descripcion}</option>`;
            }
            form.querySelector("#actividad_id").innerHTML = option_a;
          }
        });
        /* Fin de la carga estatus */
      },
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "folio_establecimiento",
            label: "Ingresa el folio del establecimiento",
            placeHolder: "Folio establecimiento",
            cols: 6,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "razon_social",
            label: "Ingresa nombre de establecimiento",
            placeHolder: "Nombre establecimiento",
            cols: 6,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "actividad_id",
            label: "Actividad del establecimiento",
            placeHolder: "actividad establecimiento",
            cols: 6,
            value: "0",
          },
        },
        {
          select: {
            type: "text",
            name: "estatus",
            label: "Estado establecimiento",
            placeHolder: "Estado establecimiento",
            cols: 6,
            value: "0",
          },
        },
      ],
    });
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            {/*<Link to="/form/elements">Home</Link>*/}
            Home
          </li>
          <li className="breadcrumb-item active">Establecimientos</li>
        </ol>
        <h1 className="page-header">Establecimientos</h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                <fieldset>
                  <div id="busqueda"></div>
                </fieldset>
                <div id="myGrid"></div>
              </div>
            </div>
          </PanelBody>
        </Panel>
      </div>
    );
  }
}

export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  return (
    <EstablecimientosCuarentena auth={auth} history={history} {...props} />
  );
};
